import {ActiveField} from '../ActiveField'

export default class RichTextField extends ActiveField {
  constructor () {
    // @ts-ignore
    super(...arguments)
    this.fieldType = 'rich-text'
  }
}